import type { RouteRecordRaw } from 'vue-router'
import { Layout } from '@/utils/routerHelper'

const agentRoutes: RouteRecordRaw[] = [
  {
    path: '/agent',
    name: 'Agent',
    component: Layout,
    meta: {
      title: '代理管理',
      icon: 'vi-ant-design:team-outlined',
      alwaysShow: true
    },
    children: [
      {
        path: 'list',
        component: () => import('@/views/Agent/AgentList.vue'),
        name: 'AgentList',
        meta: { title: '代理列表' }
      },
      {
        path: 'apply',
        component: () => import('@/views/Agent/ApplyList.vue'),
        name: 'AgentApplyList',
        meta: { title: '申请审核', hidden: true }
      },
      {
        path: 'real-list',
        component: () => import('@/views/Agent/RealList.vue'),
        name: 'AgentRealList',
        meta: { title: '实名认证' }
      },
      {
        path: 'bind',
        component: () => import('@/views/Agent/BindList.vue'),
        name: 'AgentBindList',
        meta: { title: '用户绑定' }
      },
      {
        path: 'school',
        component: () => import('@/views/Agent/SchoolList.vue'),
        name: 'AgentSchoolList',
        meta: { title: '学校管理' }
      },
      {
        path: 'course',
        component: () => import('@/views/Agent/CourseList.vue'),
        name: 'AgentCourseList',
        meta: { title: '培训班管理' }
      },
      {
        path: 'agent-bind',
        component: () => import('@/views/Agent/AgentBindList.vue'),
        name: 'AgentAgentBindList',
        meta: { title: '代理绑定' }
      },
      {
        path: 'school-bind',
        component: () => import('@/views/Agent/SchoolBindList.vue'),
        name: 'AgentSchoolBindList',
        meta: { title: '学校绑定' }
      }
    ]
  },
  {
    path: '/agent-finance',
    name: 'AgentFinance',
    component: Layout,
    meta: {
      title: '代理财务',
      icon: 'vi-ep:wallet',
      alwaysShow: true
    },
    children: [
      {
        path: 'finance',
        component: () => import('@/views/Agent/FinanceList.vue'),
        name: 'AgentFinanceList',
        meta: { title: '财务管理' }
      },
      {
        path: 'wallet',
        component: () => import('@/views/Agent/WalletList.vue'),
        name: 'AgentWalletList',
        meta: { title: '余额管理' }
      },
      {
        path: 'withdraw',
        component: () => import('@/views/Agent/WithdrawList.vue'),
        name: 'AgentWithdrawList',
        meta: { title: '提现管理' }
      },
      {
        path: 'card',
        component: () => import('@/views/Agent/CardList.vue'),
        name: 'AgentCardList',
        meta: { title: '银行卡管理' }
      },
      {
        path: 'payment',
        component: () => import('@/views/Agent/QrcodeList.vue'),
        name: 'AgentPaymentList',
        meta: { title: '二维码管理' }
      },
      {
        path: 'reward',
        component: () => import('@/views/Agent/RewardList.vue'),
        name: 'AgentRewardList',
        meta: { title: '佣金管理', hidden: true }
      },
      {
        path: 'reward-log',
        component: () => import('@/views/Agent/RewardLogList.vue'),
        name: 'AgentRewardLogList',
        meta: { title: '分账记录' }
      },
      {
        path: 'money-log',
        component: () => import('@/views/Agent/MoneyLogList.vue'),
        name: 'AgentMoneyLogList',
        meta: { title: '资金日志' }
      },
      {
        path: 'tax-rate',
        component: () => import('@/views/Agent/TaxRateList.vue'),
        name: 'AgentTaxRateList',
        meta: { title: '税率配置' }
      }
    ]
  },
  {
    path: '/agent-report',
    name: 'AgentReport',
    component: Layout,
    meta: {
      title: '代理报表',
      icon: 'vi-ep:data-analysis',
      alwaysShow: true
    },
    children: [
      {
        path: 'daily',
        component: () => import('@/views/Agent/ReportDaily.vue'),
        name: 'AgentReportDaily',
        meta: { title: '日报表' }
      },
      {
        path: 'logs',
        component: () => import('@/views/Agent/LogsList.vue'),
        name: 'AgentLogsList',
        meta: { title: '操作日志' }
      }
    ]
  },
  {
    path: '/region',
    name: 'Region',
    component: Layout,
    meta: {
      title: '地区管理',
      icon: 'vi-ep:location',
      alwaysShow: true
    },
    children: [
      {
        path: 'list',
        component: () => import('@/views/Agent/RegionList.vue'),
        name: 'RegionList',
        meta: { title: '地区列表' }
      }
    ]
  },
  {
    path: '/notice',
    name: 'Notice',
    component: Layout,
    meta: {
      title: '公告管理',
      icon: 'vi-ep:bell',
      alwaysShow: true
    },
    children: [
      {
        path: 'list',
        component: () => import('@/views/Agent/NoticeList.vue'),
        name: 'NoticeList',
        meta: { title: '公告列表' }
      }
    ]
  }
]

export default agentRoutes
